import { AppViewProperty, AppViewPropertyKey } from '../../state/appViewProperties/types';

type GetAppViewPropertyRequestStatusId = (
  entityId: AppViewProperty['id'],
  propertyKeys: AppViewPropertyKey[]
) => string;

export const getAppViewPropertyRequestStatusId: GetAppViewPropertyRequestStatusId = (entityId, propertyKeys) => {
  const id = entityId + '/' + propertyKeys.join('/');

  return id;
};
